export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	pikachuworld: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	nidoranf: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	nidorina: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	nidoqueen: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	nidoranm: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	nidorino: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	nidoking: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	zubat: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	golbat: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	crobat: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	slowkinggalar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	smoochum: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	jynx: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	elekid: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	electabuzz: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	electivire: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	magby: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	magmar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	magmortar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	omanyte: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	omastar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	kabuto: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	kabutops: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	aerodactyl: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	articuno: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	articunogalar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	zapdos: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	zapdosgalar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	moltres: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	moltresgalar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	dratini: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	dragonair: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	dragonite: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	raikou: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	entei: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	suicune: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	lugia: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	hooh: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	treecko: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	grovyle: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	sceptile: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	torchic: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	combusken: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	blaziken: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	mudkip: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	marshtomp: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	swampert: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	aron: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	lairon: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	aggron: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	swablu: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	altaria: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	lileep: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	cradily: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	anorith: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	armaldo: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	absol: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	spheal: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	sealeo: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	walrein: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	bagon: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	shelgon: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	salamence: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	beldum: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	metang: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	metagross: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	regirock: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	regice: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	registeel: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	latias: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	latios: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	kyogre: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	groudon: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	rayquaza: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	spiritomb: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	gible: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	gabite: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	garchomp: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	uxie: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	mesprit: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	azelf: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	dialga: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	palkia: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	heatran: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	regigigas: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	giratina: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	giratinaorigin: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	cresselia: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	victini: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	audino: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	tirtouga: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	carracosta: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	archen: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	archeops: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	cryogonal: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	tornadus: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	tornadustherian: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	thundurus: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	thundurustherian: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	landorus: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	landorustherian: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	genesect: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	genesectburn: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	genesectchill: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	genesectdouse: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	genesectshock: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	tyrunt: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	tyrantrum: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	amaura: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	aurorus: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	carbink: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	xerneas: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	yveltal: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	zygarde: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	zygarde10: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	diancie: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	volcanion: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	tapukoko: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	tapulele: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	tapubulu: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	tapufini: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	nihilego: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	buzzwole: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	pheromosa: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	xurkitree: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	celesteela: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	kartana: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	guzzlord: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	poipole: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	naganadel: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	stakataka: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	blacephalon: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	melmetal: {
		gmaxUnreleased: true,
	},
	melmetalgmax: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	zarudedada: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	regieleki: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	regidrago: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	glastrier: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	spectrier: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	calyrex: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	calyrexice: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	calyrexshadow: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
};
